import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { PaymentCollectionType } from './payment-collection-type';

@inheritSerialization(AbstractModel)
export class PaymentMethod extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserializeAs(PaymentCollectionType)
  paymentCollectionType: PaymentCollectionType;
}
